/* eslint-disable */
// antd V5
const theme = {
  colorPrimary: '#1a78a5',
  // colorPrimaryBg: '#daf2e9',
  // colorPrimaryBgHover: '#93e6c7',
  // colorPrimaryBorder: '#68d9b3',
  // colorPrimaryBorderHover: '#41cca2',
  // colorPrimaryHover: '#1fbf94',
  // colorPrimaryActive: '#008c70',
  // colorPrimaryTextHover: '#1fbf94',
  // colorPrimaryText: '#00b38a',
  // colorPrimaryTextActive: '#008c70',
  colorLink: '#e95773',
  colorLinkHover: '#1a78a5',
  // 勿将 colorFillTertiary / colorBgTextHover 设为主色实色：AntD 中 controlItemBgHover === colorFillTertiary，
  // 会导致 Select/Dropdown 选项悬停为深蓝底而文字仍为深色，对比度极差。
  colorBgContainerDisabled: 'rgba(0, 0, 0, 0.04)',
  colorTextDisabled: 'rgba(0, 0, 0, 0.8)',
  fontFamily: ` "PingFang SC", "Microsoft YaHei", "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "Hiragino Sans GB", "Helvetica Neue", Helvetica, Arial, sans-serif,
  "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`
}
export default theme
